import { useSelector } from "react-redux";
import { RootState } from "../store/rootReducer";
import { useTranslation } from "react-i18next";
import { getOptions } from "../lib/util";

const useUtil = () => {
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { i18n } = useTranslation();
  
  const getDetailCodes = (commonCode: string) => {
    const commonCodeObj = commonCodes.find(
      item => item.commonCode === commonCode
    );
    return commonCodeObj?.detailCode || [];
  };

  const setCookie = (name: string, value: any, day: number) => {
    const date = new Date();
    date.setTime(date.getTime() + day * 60 * 60 * 24 * 1000);
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
  }

  const getCookie = (name: string) => {
    const value = document.cookie.match(`(^|;)?${name}=([^;]*)(;|$)`);
    return value ? value[2] : null;
  }


  const getDetailCodeOptions = (
    detailCodes: string,
    includeAll: boolean = false,
    language: string = i18n.language,
  ) => {
    return getOptions(
      getDetailCodes(detailCodes),
      language === 'ko' ? 'korName' : 'engName',
      'detailCode',
      includeAll,
      language,
    );
  };

  const getCommonCodeLabel = (
    commonCode: string,
    detailCode: any,
    language?: string,
  ) => {
    const detailCodes = getDetailCodes(commonCode);
    const detailCodeObj = detailCodes.find(item => item.detailCode === detailCode);
    return (language || i18n.language) === 'ko'
      ? detailCodeObj?.korName || ''
      : detailCodeObj?.engName || '';
  };

  const isCampusDeactived = () => {
    if (currentCampus && campusData) {
      const campus = campusData.find((item: any) => item.campusCode === currentCampus)
      if (campus) {
        return campus.campusStatus === "TM";
      }
    }
    return false;
  };

  const getChunkArray = (data = [] as any, size = 1) => {
    const arr = [];

    for (let i = 0; i < data.length; i += size) {
      arr.push(data.slice(i, i + size));
    }

    return arr;
  }
    
  return {
    getDetailCodes,
    getDetailCodeOptions,
    getCommonCodeLabel,
    isCampusDeactived,
    getChunkArray,
    setCookie,
    getCookie
  };
};

export default useUtil;